export class RequestLog {
  static get PROPIEDADES_EXPORTAR() {
    return [
      { value: "Id", label: "Id" },
      { value: "CompaniaId", label: "Compañía Id" },
      { value: "DireccionIP", label: "Dirección IP" },
      { value: "Headers", label: "Headers" },
      { value: "Method", label: "Method" },
      { value: "EndPoint", label: "EndPoint" },
      { value: "Contenido", label: "Contenido" },
      { value: "Respuesta", label: "Respuesta" },
      { value: "TransaccionId", label: "TransaccionId" },
      { value: "FechaCreacion", label: "Fecha Creación" },
      { value: "FechaActualizacion", label: "Fecha Actualización" },
    ]
  }
}